module.exports = __webpack_public_path__ + "img/202.2b66ce2c.png";